'use strict';

const find = require('lodash/find');

const getCookie = require('util/getCookie');

function controller($attrs, $http, $window, appConfig) {
    const vm = this;
    vm.query = '';
    vm.loading = true;
    vm.amount = parseFloat($attrs.defaultValue);

    const membership = getCookie(document.cookie, '_bo_memberships');

    if ($attrs.accountAttributeId) {
        $http.get(`${appConfig.ticketingEndpoint}/user/attribute/check/${$attrs.accountAttributeId}`, {
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
            },
        })
            .then(response => {
                if (response.data.attribute_value) {
                    vm.amount = parseFloat(response.data.attribute_value, 10);
                }
            })
            .finally(() => {
                vm.loading = false;
            })
    } else if (membership) {
        $http.get(`${appConfig.ticketingEndpoint}/api/membership-donations.json`)
            .then(response => {
                const constituencyData = find(response.data, constituency => {
                    return constituency.constituency === membership;
                });
                if (constituencyData && constituencyData.value) {
                    vm.amount = parseFloat(constituencyData.value);
                }
            })
            .finally(() => {
                vm.loading = false;
            });
    } else {
        vm.loading = false;
    }

    vm.submit = ev => {
        ev.preventDefault();
        const donationUrl = `${appConfig.ticketingEndpoint}/support/donate?fund=${$attrs.fundId}&amount=${vm.amount}&contrib_source=${$attrs.sourceId}`;
        console.log('Redirect to:', donationUrl);
        $window.location.href = donationUrl;
    }

    return vm;
}

module.exports = [
    '$attrs',
    '$http',
    '$window',
    'appConfig',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/Donation.js